import { useEffect } from 'react';

import { IS_IFRAME_MODE } from 'config/envVariable';
import { scrollElementIntoView } from 'client/utils/scroll';
import useElementRefState from 'hooks/useElementRefState';

export default function useScrollElementOnMount({
    trigger = true,
    block = 'center',
    enableOnlyIfEmbeded = true
} = {}) {
    const [contentRef, bindRef] = useElementRefState();
    useEffect(() => {
        if (contentRef && trigger) {
            if (enableOnlyIfEmbeded) {
                if (IS_IFRAME_MODE) {
                    scrollElementIntoView(contentRef, block);
                }
            } else {
                scrollElementIntoView(contentRef, block);
            }
        }
    }, [contentRef, block, trigger, enableOnlyIfEmbeded]);

    return bindRef;
}
